function WebDevelopment() {
    return (
        <div class="app-development Web-development_Wrapper wow fadeIn" style={{ marginTop: "5.2%" }}>
            <section class="banner_wrapper wow fadeIn" style={{ visibility: "visible" }}>
                {/* <!-- id="module" --> */}
                <div id="element2"> </div>
                <div class="container">
                    <div class="Banner_content">
                        <div class="Bnr_left bnr-cmn">
                            <div class="hero_text">
                                <h1 data-aos="zoom-in"
                                    data-aos-duration="300"
                                    data-aos-easing="ease-in-sine">Web Development</h1>
                            </div>
                            {/* <!-- cd-intro --> */}
                            <p data-aos="fade-up"
                                data-aos-duration="1000"
                                data-aos-easing="ease-in-sine">Out-Of-The-Box Web Development Services You Can Afford All Of Our Services Are Out Of The World And Spills Creativity On Every Page You Visit.
                            </p>
                        </div>
                    </div>
                </div>

            </section>
            {/* <!-- App content -->
            <!-- end---here --> */}

            <section class="Our-Service_wrapper AppConten_wrp WebContent_wrp wow fadeIn" style={{ visibility: "visible" }}>
                <div class="container">
                    <div class="Srv-heading">
                        <h2 data-aos="zoom-in"
                            data-aos-duration="300"
                            data-aos-easing="ease-in-sine">Showcase Your Business In The Most Effective Way</h2>
                        <p data-aos="fade-up"
                            data-aos-duration="1000"
                            data-aos-easing="ease-in-sine">In Today's World, It's Very Essential To Showcase Your Ubiquity Online. And The Best Method To Do It Is To Have A Promising Website. Out In The Vast Ocean Of The Web, You May Confront Billions Of Websites But Very Few Of Them Are Going To Draw You And Compel You To Browse Even Further.  We Help Develop Excellent Websites That Surpass The Internet. With The Help Of Our Designed Sites, You Can Easily Grow Your Business Anywhere You Like And Grow Your Profits To The Maximum.
                        </p>
                    </div>
                    <div class="App_cnt webdesign">
                        <div class="left_app1 left-cmn01" data-tilt data-tilt-glare data-tilt-max-glare="0.8">
                            <figure data-aos="fade-left"
                                data-aos-duration="300"
                                data-aos-easing="ease-in-sine">
                                <img src="image/webdesign.gif" alt="img" />
                            </figure>
                        </div>
                        <div class="right_app1 left-cmn01">
                            <h2 data-aos="fade-right"
                                data-aos-duration="300"
                                data-aos-easing="ease-in-sine">Website Designing</h2>
                            <p data-aos="fade-right"
                                data-aos-duration="1100"
                                data-aos-easing="ease-in-sine">We can create your website, and it will be created as per your requirements. Whether you are a start-up or a tech giant, we are here to provide the best class web Designing services to all.
                            </p>
                            {/* <!-- <a data-aos="fade-right"
                                data-aos-duration="1500"
                                data-aos-easing="ease-in-sine" href="webdesign.html" class="hvr-bounce-to-right">learn more</a> --> */}
                        </div>
                    </div>
                    <div class="App_cnt Eccommerce">
                        <div class="left_app1 left-cmn01" data-tilt data-tilt-glare data-tilt-max-glare="0.8">
                            <figure data-aos="fade-right"
                                data-aos-duration="300"
                                data-aos-easing="ease-in-sine">
                                <img src="image/eccommerce1.gif" alt="img" />
                            </figure>
                        </div>
                        <div class="right_app1 left-cmn01">
                            <h2 data-aos="fade-left"
                                data-aos-duration="300"
                                data-aos-easing="ease-in-sine">E-Commerce Solution</h2>
                            <p data-aos="fade-left"
                                data-aos-duration="1000"
                                data-aos-easing="ease-in-sine">We have the right expertise to develop an e-commerce website that is eye-catchy, fast, and free from bugs.
                            </p>
                            {/* <!-- <a data-aos="fade-left"
                                data-aos-duration="1500"
                                data-aos-easing="ease-in-sine" href="eccommerce.html" class="hvr-bounce-to-right">learn more</a> --> */}
                        </div>
                    </div>
                    {/* <!-- <div class="App_cnt Dynamic-web">
                        <div class="left_app1 left-cmn01" data-tilt data-tilt-glare data-tilt-max-glare="0.8">
                            <figure data-aos="fade-left"
                                data-aos-duration="500"
                                data-aos-easing="ease-in-sine">
                                <img src="image/web_developing.gif" alt="img"/>
                            </figure>
                        </div>
                        <div class="right_app1 left-cmn01">
                            <h2 data-aos="fade-right"
                                data-aos-duration="500"
                                data-aos-easing="ease-in-sine">Dynamic Web Design </h2>
                            <p data-aos="fade-right"
                                data-aos-duration="1400"
                                data-aos-easing="ease-in-sine">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ipsum incidunt laborum, tempore odit quod ullam maiores exercitationem dignissimos, eaque asperiores, officiis enim excepturi dolorum similique.
                                Ipsum incidunt laborum, tempore odit quod ullam maiores exercitationem dignissimos, eaque asperiores, officiis enim excepturi dolorum similique.
                            </p>
                            <a data-aos="fade-right"
                                data-aos-duration="1500"
                                data-aos-easing="ease-in-sine" href="dynamicwebsite.html" class="hvr-bounce-to-right">learn more</a>
                        </div> --> */}
                    <div class="App_cnt Dynamic-web">
                        <div class="left_app1 left-cmn01" data-tilt data-tilt-glare data-tilt-max-glare="0.8">
                            <figure data-aos="fade-left"
                                data-aos-duration="300"
                                data-aos-easing="ease-in-sine">
                                <img src="image/web_developing.gif" alt="img" />
                            </figure>
                        </div>
                        <div class="right_app1 left-cmn01">
                            <h2 data-aos="fade-right"
                                data-aos-duration="300"
                                data-aos-easing="ease-in-sine">Web Application Support and Maintenance</h2>
                            <p data-aos="fade-right"
                                data-aos-duration="1000"
                                data-aos-easing="ease-in-sine">Just like web designing and development is an integral part of a website, maintaining it and updating it are vital components. We provide bespoke support and maintenance service!.
                            </p>
                            {/* <!-- <a data-aos="fade-right"
                                    data-aos-duration="1500"
                                    data-aos-easing="ease-in-sine" href="dynamicwebsite.html" class="hvr-bounce-to-right">learn more</a> --> */}
                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default WebDevelopment